/**
 * Helvetica Font for MeshWriter
 * Pre-initialized FontSpec format
 * @type {import("../src/types").FontSpec}
 */
export default {
    reverseHoles: false,
    reverseShapes: true,
    "0": {
        sC: [
            "EoLV G¡LVHwJc IRI*IRF¡ IRDRHwB½ G¡A%EoA% C_A%BgB½ A­DRA­F¡ A­I*BgJc C_LVEoLV",
        ],
        hC: [
            ["EoBe GoBeGoF¡ GoJ»EoJ» CoJ»CoF¡ CoBeEoBe"],
        ],
        xMin: 36,
        xMax: 520,
        yMin: -14,
        yMax: 714,
        wdth: 556
    },
    "1": {
        sC: [
            "D§HÁ B,HÁ B,JR CHJPD4J© E,KDEDL: F¡L: F¡AB D§AB D§HÁ",
        ],
        xMin: 53,
        xMax: 350,
        yMin: 0,
        yMax: 700,
        wdth: 556
    },
    "2": {
        sC: [
            "D!B± ILB± ILAB A³AB AµC£DDET E#E·E¥FT FoFÃG#Ge GiH<GkHÃ GmI£G>JB F¥J»E¡J» C»J»C±H: B*H: B*J*C%K< D(LVE¯LV GuLVHoKB INJLINI( ING*F¹EP F!D¥E.D4 D<C]D!B±",
        ],
        xMin: 39,
        xMax: 518,
        yMin: 0,
        yMax: 714,
        wdth: 556
    },
    "3": {
        sC: [
            "D­FL D­Gw E¯GqF_H! G@HZG@IR G@J*F¦Jb FFJ»EgJ» DwJ»D8JC C{IoC¡H{ A½H{ B#JLB¿KN C¿LVEkLV F¿LVG»Ky I#J³I#Ia I#G{G_G4 G_G0 HTF»H»F9 I]EZI]DR I]BµHHA½ G<A%EmA% C£A%B¡B, A§C,A£D± CeD± CaC­D#C: DkBeEmBe FcBeG-C& GyCkGyD_ GyF]D­FL",
        ],
        xMin: 31,
        xMax: 525,
        yMin: -14,
        yMax: 714,
        wdth: 556
    },
    "4": {
        sC: [
            "H!EB IVEB IVC± H!C± H!AB FJAB FJC± AsC± AsEq FJL: H!L: H!EB",
        ],
        hC: [
            ["FJJ* FFJ* C!EB FJEB FJJ*"],
        ],
        xMin: 24,
        xMax: 522,
        yMin: 0,
        yMax: 700,
        wdth: 556
    },
    "5": {
        sC: [
            "C©F< B!F< C8L: H¯L: H¯Jo DcJo C½G­ CÁG© D¡HqEÃHq GmHqHeGk IVFkIVD¿ IVCZHgBN GaA%EsA% CÃA%B¿Aµ A³B§A«DP CmDP CwCaD:C! D¡BeEoBe GsBeGsD» GsE·G2Fe FkG<EiG< D6G<C©F<",
        ],
        xMin: 35,
        xMax: 522,
        yMin: -14,
        yMax: 700,
        wdth: 556
    },
    "6": {
        sC: [
            "I<IX GXIX GPJ.F½Jd FeJ»E¯J» DkJ»D#Io C{H«CkG8 CoG4 DLHZE¿HZ GiHZHcGT IVFRIVD§ IVC6HUB. GTA%E§A% CgA%BkB} A©D*A©F¥ A©I%B{Jk C©LVE¹LV G@LVH:Kl I4J£I<IX",
        ],
        hC: [
            ["E}Be FqBeG4C> GsC³GsD« GsE£G2FS FsG%E}G% D§G%D@FP C£E¥C£D« C£C±D@C> D©BeE}Be"],
        ],
        xMin: 34,
        xMax: 522,
        yMin: -14,
        yMax: 714,
        wdth: 556
    },
    "7": {
        sC: [
            "G_Jo A«Jo A«L: IFL: IFJ} EmFeE<AB CBAB CXC£DqFD E}HoG_Jo",
        ],
        xMin: 35,
        xMax: 514,
        yMin: 0,
        yMax: 700,
        wdth: 556
    },
    "8": {
        sC: [
            "EoA% C·A%B­AÀ A£B·A£D_ A£EaBEF; B­F¹C£G4 C£G6 B:G§B:IX B:J¯C,Kr CÁLVEoLV G>LVH0Kr I!J¯I!IX I!G§G]G6 G]G4 HRF¹HºF; I]EaI]D_ I]B·HRAÀ GHA%EoA%",
        ],
        hC: [
            ["EoBZ FcBZG-BÃ GyCgGyD_ GyEPG-Eµ FcFTEoFT D{FTD/Eµ CeEPCeD_ CeCgD/BÃ D{BZEoBZ","EoK! D±K!DPJj CµJ0CµIL CµHmDOH5 D¯G¡EoG¡ FPG¡F°H5 GJHmGJIL GJJ0F¯Jj FNK!EoK!"],
        ],
        xMin: 31,
        xMax: 525,
        yMin: -14,
        yMax: 714,
        wdth: 556
    },
    "9": {
        sC: [
            "AÃD# C§D# C¯CNDBB¼ DyBeEPBe FsBeG8C³ GcDuGsFD GoFH F³DÃE@DÃ C{DÃB£EÄ A©G!A©Hy A©JJBªKP C«LVEiLV G}LVHuJ¥ IVIRIVF{ IVDVHcBµ GVA%EFA% C¿A%C!A´ B(B}AÃD#",
        ],
        hC: [
            ["E_J» DiJ»D%JB CkIuCkH{ CkG¡D%G. DiFTE_FT FXFTF¿G. G]G¡G]H{ G]IsF½JE FXJ»E_J»"],
        ],
        xMin: 34,
        xMax: 522,
        yMin: -14,
        yMax: 714,
        wdth: 556
    },
    "a": {
        sC: [
            "H¿G< H¿C( H¿BZIRBZ IsBZI­B_ I­A@ I@A%H{A% GcA%GJB# FJA%DeA% CNA%BoAs A¥BDA¥CT A¥D£B¥EL CPE{D³E¹ FiF6FiF6 GFFRGFG( GFH4EqH4 C½H4C¯F³ B(F³ B<IiE¡Ii G(IiG»I# H¿HTH¿G<",
        ],
        hC: [
            ["G8CÁ G8EH F¯E,F8DÁ EmD·DÃD­ CgDkCgC_ CgB½D2Bw DmBZE8BZ E·BZF_B© G8C<G8CÁ"],
        ],
        xMin: 32,
        xMax: 548,
        yMin: -14,
        yMax: 531,
        wdth: 556
    },
    "\u00e1": {
        sC: [
            "",
            "H¿G< H¿C( H¿BZIRBZ IsBZI­B_ I­A@ I@A%H{A% GcA%GJB# FJA%DeA% CNA%BoAs A¥BDA¥CT A¥D£B¥EL CPE{D³E¹ FiF6FiF6 GFFRGFG( GFH4EqH4 C½H4C¯F³ B(F³ B<IiE¡Ii G(IiG»I# H¿HTH¿G<",
        ],
        hC: [
            [],
            ["G8CÁ G8EH F¯E,F8DÁ EmD·DÃD­ CgDkCgC_ CgB½D2Bw DmBZE8BZ E·BZF_B© G8C<G8CÁ"],
        ],
        xMin: 32,
        xMax: 548,
        yMin: -14,
        yMax: 731,
        wdth: 556
    },
    "\u00e0": {
        sC: [
            "",
            "H¿G< H¿C( H¿BZIRBZ IsBZI­B_ I­A@ I@A%H{A% GcA%GJB# FJA%DeA% CNA%BoAs A¥BDA¥CT A¥D£B¥EL CPE{D³E¹ FiF6FiF6 GFFRGFG( GFH4EqH4 C½H4C¯F³ B(F³ B<IiE¡Ii G(IiG»I# H¿HTH¿G<",
        ],
        hC: [
            [],
            ["G8CÁ G8EH F¯E,F8DÁ EmD·DÃD­ CgDkCgC_ CgB½D2Bw DmBZE8BZ E·BZF_B© G8C<G8CÁ"],
        ],
        xMin: 32,
        xMax: 548,
        yMin: -14,
        yMax: 731,
        wdth: 556
    },
    "\u00e4": {
        sC: [
            "",
            "",
            "H¿G< H¿C( H¿BZIRBZ IsBZI­B_ I­A@ I@A%H{A% GcA%GJB# FJA%DeA% CNA%BoAs A¥BDA¥CT A¥D£B¥EL CPE{D³E¹ FiF6FiF6 GFFRGFG( GFH4EqH4 C½H4C¯F³ B(F³ B<IiE¡Ii G(IiG»I# H¿HTH¿G<",
        ],
        hC: [
            [],
            [],
            ["G8CÁ G8EH F¯E,F8DÁ EmD·DÃD­ CgDkCgC_ CgB½D2Bw DmBZE8BZ E·BZF_B© G8C<G8CÁ"],
        ],
        xMin: 32,
        xMax: 548,
        yMin: -14,
        yMax: 707,
        wdth: 556
    },
    "\u00e2": {
        sC: [
            "",
            "H¿G< H¿C( H¿BZIRBZ IsBZI­B_ I­A@ I@A%H{A% GcA%GJB# FJA%DeA% CNA%BoAs A¥BDA¥CT A¥D£B¥EL CPE{D³E¹ FiF6FiF6 GFFRGFG( GFH4EqH4 C½H4C¯F³ B(F³ B<IiE¡Ii G(IiG»I# H¿HTH¿G<",
        ],
        hC: [
            [],
            ["G8CÁ G8EH F¯E,F8DÁ EmD·DÃD­ CgDkCgC_ CgB½D2Bw DmBZE8BZ E·BZF_B© G8C<G8CÁ"],
        ],
        xMin: 32,
        xMax: 548,
        yMin: -14,
        yMax: 731,
        wdth: 556
    },
    "\u00e5": {
        sC: [
            "",
            "H¿G< H¿C( H¿BZIRBZ IsBZI­B_ I­A@ I@A%H{A% GcA%GJB# FJA%DeA% CNA%BoAs A¥BDA¥CT A¥D£B¥EL CPE{D³E¹ FiF6FiF6 GFFRGFG( GFH4EqH4 C½H4C¯F³ B(F³ B<IiE¡Ii G(IiG»I# H¿HTH¿G<",
        ],
        hC: [
            [""],
            ["G8CÁ G8EH F¯E,F8DÁ EmD·DÃD­ CgDkCgC_ CgB½D2Bw DmBZE8BZ E·BZF_B© G8C<G8CÁ"],
        ],
        xMin: 32,
        xMax: 548,
        yMin: -14,
        yMax: 755,
        wdth: 556
    },
    "\u00e6": {
        sC: [
            "LµC« NwC« NJBeMLA¨ LNA%K!A% HµA%H%Be G%A%DyA% CVA%BqAs A¥BBA¥CT A¥D£B¥EL CPE{D³E¹ F]F4FcF6 G:FPG:G( G:H4EqH4 C½H4C¯F³ B(F³ B4HHCBHÃ D8IiEyIi GyIiHVH] I@IiJÁIi L¯IiM­HP N£GBN£EL N£E,N¡D¯ H³D¯ H±C¯IPC8 I»BZJÁBZ LTBZLµC«",
        ],
        hC: [
            ["G8D* G8ED F½E(FBD¿ EsD·E!D­ CgDmCgC_ CgBZE6BZ E¿BZFgB³ G8CJG8D*","H³F! L½F! L¿FÁLVGj K³H4J·H4 IÃH4IZGc H»F»H³F!"],
        ],
        xMin: 32,
        xMax: 863,
        yMin: -14,
        yMax: 531,
        wdth: 889
    },
    "b": {
        sC: [
            "C»AB B@AB B@LV D#LV D#HF D(HF DVH³E,I< E¥IiF]Ii HFIiIHHF J@G2J@EB J@CaITBL HZA%F¥A% DsA%C¿BP C»BP C»AB",
        ],
        hC: [
            ["H]EF H]F]G·GD GDH4F>H4 E2H4DhGR C¿FqC¿EF C¿D%DkC@ E8BZF>BZ GNBZG¿CL H]D.H]EF"],
        ],
        xMin: 63,
        xMax: 575,
        yMin: -14,
        yMax: 714,
        wdth: 611
    },
    "c": {
        sC: [
            "IXFs GuFs GXH4E«H4 D¹H4DNGo CmF±CmE< CmD*D*CJ DuBZE¡BZ FcBZG\"B¼ GeCXGuDF IXDF H¹A%E¡A% CµA%B­B@ A«CPA«E< A«G2B«HH C³IiE©Ii GDIiH@H¯ IHH(IXFs",
        ],
        xMin: 35,
        xMax: 523,
        yMin: -14,
        yMax: 531,
        wdth: 556
    },
    "\u00e7": {
        sC: [
            "GuDF IXDF H½A<F(A* Ec@N Ec@J Es@PF#@P Fg@PF¹@, GN?¥GN?< GN>_F£>. F@=«E]=« DV=«C±>2 D2>¥ Dµ>cE4>c F.>cF.?4 F.?XEµ?m Ew?£ER?£ E%?£D§?m DX?µ EJA* CuA:B}BP A«C_A«E< A«G2B«HH C³IiE©Ii GDIiH@H¯ IHH(IXFs GuFs GXH4E«H4 D¹H4DNGo CmF±CmE< CmD*D*CJ DuBZE¡BZ FcBZG\"B¼ GeCXGuDF",
        ],
        xMin: 35,
        xMax: 523,
        yMin: -221,
        yMax: 531,
        wdth: 556
    },
    "\u010d": {
        sC: [
            "IXFs GuFs GXH4E«H4 D¹H4DNGo CmF±CmE< CmD*D*CJ DuBZE¡BZ FcBZG\"B¼ GeCXGuDF IXDF H¹A%E¡A% CµA%B­B@ A«CPA«E< A«G2B«HH C³IiE©Ii GDIiH@H¯ IHH(IXFs",
        ],
        xMin: 35,
        xMax: 523,
        yMin: -14,
        yMax: 531,
        wdth: 556
    },
    "d": {
        sC: [
            "H#LV I«LV I«AB H0AB H0BN H,BN GVA%EmA% C£A%B£BF A«CZA«EN A«GVB·Hi C±IiEHIi G<IiGÃHF H#HF H#LV",
        ],
        hC: [
            ["CmE< CmD*D0CH D¡BZE­BZ F»BZGiCN H,D2H,EH H,FsG`GS FµH4E±H4 D{H4D,G> CmFZCmE<"],
        ],
        xMin: 35,
        xMax: 547,
        yMin: -14,
        yMax: 714,
        wdth: 611
    },
    "e": {
        sC: [
            "IeD¯ CmD¯ CmC­D0C6 D{BZE¥BZ GBBZG¡C© IVC© I2BaH1A¦ G0A%E¥A% C·A%B±B< A«CRA«EF A«G*B±HF C¿IiE}Ii GVIiHcHH IiG2IiEX IiE2IeD¯",
        ],
        hC: [
            ["CmF! G£F! G{F·G3Ge FmH4E}H4 D«H4D<Gg CqF»CmF!"],
        ],
        xMin: 35,
        xMax: 531,
        yMin: -14,
        yMax: 531,
        wdth: 556
    },
    "\u00e9": {
        sC: [
            "",
            "IeD¯ CmD¯ CmC­D0C6 D{BZE¥BZ GBBZG¡C© IVC© I2BaH1A¦ G0A%E¥A% C·A%B±B< A«CRA«EF A«G*B±HF C¿IiE}Ii GVIiHcHH IiG2IiEX IiE2IeD¯",
        ],
        hC: [
            [],
            ["CmF! G£F! G{F·G3Ge FmH4E}H4 D«H4D<Gg CqF»CmF!"],
        ],
        xMin: 35,
        xMax: 531,
        yMin: -14,
        yMax: 731,
        wdth: 556
    },
    "\u00e8": {
        sC: [
            "",
            "IeD¯ CmD¯ CmC­D0C6 D{BZE¥BZ GBBZG¡C© IVC© I2BaH1A¦ G0A%E¥A% C·A%B±B< A«CRA«EF A«G*B±HF C¿IiE}Ii GVIiHcHH IiG2IiEX IiE2IeD¯",
        ],
        hC: [
            [],
            ["CmF! G£F! G{F·G3Ge FmH4E}H4 D«H4D<Gg CqF»CmF!"],
        ],
        xMin: 35,
        xMax: 531,
        yMin: -14,
        yMax: 731,
        wdth: 556
    },
    "\u00eb": {
        sC: [
            "",
            "",
            "IeD¯ CmD¯ CmC­D0C6 D{BZE¥BZ GBBZG¡C© IVC© I2BaH1A¦ G0A%E¥A% C·A%B±B< A«CRA«EF A«G*B±HF C¿IiE}Ii GVIiHcHH IiG2IiEX IiE2IeD¯",
        ],
        hC: [
            [],
            [],
            ["CmF! G£F! G{F·G3Ge FmH4E}H4 D«H4D<Gg CqF»CmF!"],
        ],
        xMin: 35,
        xMax: 531,
        yMin: -14,
        yMax: 707,
        wdth: 556
    },
    "\u00ea": {
        sC: [
            "",
            "IeD¯ CmD¯ CmC­D0C6 D{BZE¥BZ GBBZG¡C© IVC© I2BaH1A¦ G0A%E¥A% C·A%B±B< A«CRA«EF A«G*B±HF C¿IiE}Ii GVIiHcHH IiG2IiEX IiE2IeD¯",
        ],
        hC: [
            [],
            ["CmF! G£F! G{F·G3Ge FmH4E}H4 D«H4D<Gg CqF»CmF!"],
        ],
        xMin: 35,
        xMax: 531,
        yMin: -14,
        yMax: 731,
        wdth: 556
    },
    "f": {
        sC: [
            "B¡H! ATH! ATIL B¡IL B¡J! B¡KVCVKÃ C»LVD¿LV E­LVF<LH F<J¹ E³K!ERK! DcK!DcJ6 DcIL F#IL F#H! DcH! DcAB B¡AB B¡H!",
        ],
        xMin: 9,
        xMax: 317,
        yMin: 0,
        yMax: 714,
        wdth: 315
    },
    "g": {
        sC: [
            "GµIL IwIL IwAy Iw>(E{>( DF>(CL>o B:?BB,@k C³@k D0?RE«?R Gµ?RGµAZ GµBy G±By G(ABEXAB CoABBwBe A«CsA«Ec A«G<B§HN C©IiE]Ii G:IiG±H> GµH> GµIL",
        ],
        hC: [
            ["E}Bw F«BwGRCi GµDJGµE_ GµFqGRGL F«H4E}H4 DqH4D(G@ CmFaCmEL CmD@D,Cc DwBwE}Bw"],
        ],
        xMin: 35,
        xMax: 538,
        yMin: -205,
        yMax: 531,
        wdth: 593
    },
    "h": {
        sC: [
            "CÁAB B:AB B:LV CÁLV CÁHD D!HD DNH¯DÄI: EuIiFXIi G§IiHfH± IFH4IFF« IFAB GcAB GcFL GcH4E»H4 E(H4DdGg CÁF»CÁF# CÁAB",
        ],
        xMin: 60,
        xMax: 514,
        yMin: 0,
        yMax: 714,
        wdth: 574
    },
    "i": {
        sC: [
            "D#J¡ B@J¡ B@LV D#LV D#J¡",
            "D#AB B@AB B@IL D#IL D#AB",
        ],
        xMin: 63,
        xMax: 177,
        yMin: 0,
        yMax: 714,
        wdth: 241
    },
    "\u0131": {
        sC: [
            "D#AB B@AB B@IL D#IL D#AB",
        ],
        xMin: 63,
        xMax: 177,
        yMin: 0,
        yMax: 500,
        wdth: 241
    },
    "\u00ed": {
        sC: [
            "",
            "D#AB B@AB B@IL D#IL D#AB",
        ],
        xMin: 63,
        xMax: 177,
        yMin: 0,
        yMax: 731,
        wdth: 241
    },
    "\u00ec": {
        sC: [
            "",
            "D#AB B@AB B@IL D#IL D#AB",
        ],
        xMin: 63,
        xMax: 177,
        yMin: 0,
        yMax: 731,
        wdth: 241
    },
    "\u00ef": {
        sC: [
            "",
            "",
            "D#AB B@AB B@IL D#IL D#AB",
        ],
        xMin: 63,
        xMax: 177,
        yMin: 0,
        yMax: 707,
        wdth: 241
    },
    "\u00ee": {
        sC: [
            "",
            "D#AB B@AB B@IL D#IL D#AB",
        ],
        xMin: 63,
        xMax: 177,
        yMin: 0,
        yMax: 731,
        wdth: 241
    },
    "j": {
        sC: [
            "D#J¡ B@J¡ B@LV D#LV D#J¡",
            "B@@u B@IL D#IL D#@k D#>(A}>( AR>(@¹>0 @¹?e AR?]Ae?] AÁ?]B2?¥ B@?ÃB@@u",
        ],
        xMin: -22,
        xMax: 177,
        yMin: -205,
        yMax: 714,
        wdth: 241
    },
    "k": {
        sC: [
            "D#AB B@AB B@LV D#LV D#F* G@IL IXIL FLFP I¡AB GiAB E,E8 D#D4 D#AB",
        ],
        xMin: 63,
        xMax: 542,
        yMin: 0,
        yMax: 714,
        wdth: 537
    },
    "l": {
        sC: [
            "D#AB B@AB B@LV D#LV D#AB",
        ],
        xMin: 63,
        xMax: 177,
        yMin: 0,
        yMax: 714,
        wdth: 241
    },
    "m": {
        sC: [
            "CÁAB B:AB B:IL CµIL CµH< C»H< D­IiFVIi H4IiHyH< IuIiK<Ii M¹IiM¹F¯ M¹AB L2AB L2EÁ L2G0K¹Gg KqH4JwH4 H½H4H½EÃ H½AB G6AB G6FZ G6GJF°G¢ FeH4E£H4 E!H4DaGm CÁG#CÁF( CÁAB",
        ],
        xMin: 60,
        xMax: 810,
        yMin: 0,
        yMax: 531,
        wdth: 870
    },
    "n": {
        sC: [
            "CÁAB B:AB B:IL CµIL CµH4 C¹H0 D§IiFXIi G§IiHfH± IFH4IFF« IFAB GcAB GcFL GcH4E»H4 E(H4DdGg CÁF»CÁF# CÁAB",
        ],
        xMin: 60,
        xMax: 514,
        yMin: 0,
        yMax: 531,
        wdth: 574
    },
    "\u00f1": {
        sC: [
            "",
            "CÁAB B:AB B:IL CµIL CµH4 C¹H0 D§IiFXIi G§IiHfH± IFH4IFF« IFAB GcAB GcFL GcH4E»H4 E(H4DdGg CÁF»CÁF# CÁAB",
        ],
        xMin: 60,
        xMax: 514,
        yMin: 0,
        yMax: 714,
        wdth: 574
    },
    "\u0144": {
        sC: [
            "",
            "CÁAB B:AB B:IL CµIL CµH4 C¹H0 D§IiFXIi G§IiHfH± IFH4IFF« IFAB GcAB GcFL GcH4E»H4 E(H4DdGg CÁF»CÁF# CÁAB",
        ],
        xMin: 60,
        xMax: 514,
        yMin: 0,
        yMax: 731,
        wdth: 574
    },
    "o": {
        sC: [
            "E·A% CÃA%BµB@ A­CTA­EH A­G:B¸HQ CÃIiE·Ii G«IiH¹HN IÁG:IÁEH IÁCTH¹B@ G«A%E·A%",
        ],
        hC: [
            ["E·BZ G#BZGuCN H:D2H:EH H:F]GuG@ G#H4E·H4 D§H4D4G@ CoF]CoEH CoD2D4CN D§BZE·BZ"],
        ],
        xMin: 36,
        xMax: 558,
        yMin: -14,
        yMax: 531,
        wdth: 593
    },
    "\u00f4": {
        sC: [
            "",
            "E·A% CÃA%BµB@ A­CTA­EH A­G:B¸HQ CÃIiE·Ii G«IiH¹HN IÁG:IÁEH IÁCTH¹B@ G«A%E·A%",
        ],
        hC: [
            [],
            ["E·BZ G#BZGuCN H:D2H:EH H:F]GuG@ G#H4E·H4 D§H4D4G@ CoF]CoEH CoD2D4CN D§BZE·BZ"],
        ],
        xMin: 36,
        xMax: 558,
        yMin: -14,
        yMax: 731,
        wdth: 593
    },
    "\u00f2": {
        sC: [
            "",
            "E·A% CÃA%BµB@ A­CTA­EH A­G:B¸HQ CÃIiE·Ii G«IiH¹HN IÁG:IÁEH IÁCTH¹B@ G«A%E·A%",
        ],
        hC: [
            [],
            ["E·BZ G#BZGuCN H:D2H:EH H:F]GuG@ G#H4E·H4 D§H4D4G@ CoF]CoEH CoD2D4CN D§BZE·BZ"],
        ],
        xMin: 36,
        xMax: 558,
        yMin: -14,
        yMax: 731,
        wdth: 593
    },
    "\u00f3": {
        sC: [
            "",
            "E·A% CÃA%BµB@ A­CTA­EH A­G:B¸HQ CÃIiE·Ii G«IiH¹HN IÁG:IÁEH IÁCTH¹B@ G«A%E·A%",
        ],
        hC: [
            [],
            ["E·BZ G#BZGuCN H:D2H:EH H:F]GuG@ G#H4E·H4 D§H4D4G@ CoF]CoEH CoD2D4CN D§BZE·BZ"],
        ],
        xMin: 36,
        xMax: 558,
        yMin: -14,
        yMax: 731,
        wdth: 593
    },
    "\u00f6": {
        sC: [
            "",
            "",
            "E·A% CÃA%BµB@ A­CTA­EH A­G:B¸HQ CÃIiE·Ii G«IiH¹HN IÁG:IÁEH IÁCTH¹B@ G«A%E·A%",
        ],
        hC: [
            [],
            [],
            ["E·BZ G#BZGuCN H:D2H:EH H:F]GuG@ G#H4E·H4 D§H4D4G@ CoF]CoEH CoD2D4CN D§BZE·BZ"],
        ],
        xMin: 36,
        xMax: 558,
        yMin: -14,
        yMax: 707,
        wdth: 593
    },
    "p": {
        sC: [
            "D#>D B@>D B@IL C»IL C»H@ C¿H@ DyIiF]Ii HFIiIHHF J@G2J@EB J@CaITBL HZA%F¥A% D±A%D(BH D#BH D#>D",
        ],
        hC: [
            ["H]EF H]F]G·GD GDH4F>H4 E2H4DhGR C¿FqC¿EF C¿D%DkC@ E8BZF>BZ GNBZG¿CL H]D.H]EF"],
        ],
        xMin: 63,
        xMax: 575,
        yMin: -191,
        yMax: 531,
        wdth: 611
    },
    "q": {
        sC: [
            "H0IL I«IL I«>D H#>D H#BH GÃBH G:A%EFA% CoA%BuBL A«CaA«EB A«G2B£HF C¥IiEmIi GPIiH,H@ H0H@ H0IL",
        ],
        hC: [
            ["CmEF CmD.D.CL D{BZE­BZ F½BZGgC@ H,CÁH,EF H,FqGbGR F¹H4E­H4 D§H4D4GD CmF]CmEF"],
        ],
        xMin: 35,
        xMax: 547,
        yMin: -191,
        yMax: 531,
        wdth: 611
    },
    "r": {
        sC: [
            "CÁAB B:AB B:IL C³IL C³G§ C·G§ D(HZD¥HÄ E]IiFBIi F]IiF»Ic F»G© FHG³F6G³ E<G³DqG4 CÁFTCÁE. CÁAB",
        ],
        xMin: 60,
        xMax: 363,
        yMin: 0,
        yMax: 531,
        wdth: 352
    },
    "s": {
        sC: [
            "A¥C± CgC± CwBZEPBZ G<BZG6Cc G2DBE¥Dm C]E4CDE@ A»E¯A»G@ A»HZC*I( CÁIiEHIi FwIiGgHÃ HeHLHyG* F­G* FqH4E8H4 C}H4C}GJ C}F¥DgF] D{FTFLF# GiE£H2EL H½D£H½Cw H½BLG§As F©A%ELA% C£A%B«A¡ A§B_A¥C±",
        ],
        xMin: 32,
        xMax: 492,
        yMin: -14,
        yMax: 531,
        wdth: 519
    },
    "t": {
        sC: [
            "B¡H! ARH! ARIL B¡IL B¡K¥ DcK¥ DcIL F0IL F0H! DcH! DcC{ DcC*DsB³ D«BmEPBm E³BmF0Bu F0AD D½A8D¿A8 CuA8C4A} B¡B4B¡C@ B¡H!",
        ],
        xMin: 8,
        xMax: 311,
        yMin: -5,
        yMax: 672,
        wdth: 333
    },
    "u": {
        sC: [
            "GcIL IFIL IFAB GgAB GgBR GcBR G8A©FfAV EµA%E<A% B:A%B:D< B:IL CÁIL CÁDR CÁBZEeBZ GcBZGcDu GcIL",
        ],
        xMin: 60,
        xMax: 514,
        yMin: -14,
        yMax: 517,
        wdth: 574
    },
    "\u00fa": {
        sC: [
            "",
            "GcIL IFIL IFAB GgAB GgBR GcBR G8A©FfAV EµA%E<A% B:A%B:D< B:IL CÁIL CÁDR CÁBZEeBZ GcBZGcDu GcIL",
        ],
        xMin: 60,
        xMax: 514,
        yMin: -14,
        yMax: 731,
        wdth: 574
    },
    "\u00f9": {
        sC: [
            "",
            "GcIL IFIL IFAB GgAB GgBR GcBR G8A©FfAV EµA%E<A% B:A%B:D< B:IL CÁIL CÁDR CÁBZEeBZ GcBZGcDu GcIL",
        ],
        xMin: 60,
        xMax: 514,
        yMin: -14,
        yMax: 731,
        wdth: 574
    },
    "\u00fc": {
        sC: [
            "",
            "",
            "GcIL IFIL IFAB GgAB GgBR GcBR G8A©FfAV EµA%E<A% B:A%B:D< B:IL CÁIL CÁDR CÁBZEeBZ GcBZGcDu GcIL",
        ],
        xMin: 60,
        xMax: 514,
        yMin: -14,
        yMax: 707,
        wdth: 574
    },
    "\u00fb": {
        sC: [
            "",
            "GcIL IFIL IFAB GgAB GgBR GcBR G8A©FfAV EµA%E<A% B:A%B:D< B:IL CÁIL CÁDR CÁBZEeBZ GcBZGcDu GcIL",
        ],
        xMin: 60,
        xMax: 514,
        yMin: -14,
        yMax: 731,
        wdth: 574
    },
    "v": {
        sC: [
            "FLAB DLAB ATIL CLIL ERC2 EVC2 GRIL I>IL FLAB",
        ],
        xMin: 9,
        xMax: 510,
        yMin: 0,
        yMax: 517,
        wdth: 519
    },
    "w": {
        sC: [
            "E¯AB C¿AB A]IL CNIL D»CH D¿CH F_IL HDIL I¡CH I¥CH KTIL M<IL JyAB H±AB GNGB GJGB E¯AB",
        ],
        xMin: 13,
        xMax: 765,
        yMin: 0,
        yMax: 517,
        wdth: 778
    },
    "x": {
        sC: [
            "CVAB AJAB DPEc AkIL C¡IL EVF± G8IL I@IL FaEo ImAB GZAB ETD@ CVAB",
        ],
        xMin: 4,
        xMax: 533,
        yMin: 0,
        yMax: 517,
        wdth: 537
    },
    "y": {
        sC: [
            "D6@w DPAF AHIL CBIL EPCH ETCH GZIL IHIL F6@­ Es?RE>>µ Di>(CH>( By>(B*>4 B*?u B¡?gB¹?g C_?gC§?± CÁ@*D6@w",
        ],
        xMin: 3,
        xMax: 515,
        yMin: -205,
        yMax: 517,
        wdth: 519
    },
    "\u00ff": {
        sC: [
            "",
            "",
            "D6@w DPAF AHIL CBIL EPCH ETCH GZIL IHIL F6@­ Es?RE>>µ Di>(CH>( By>(B*>4 B*?u B¡?gB¹?g C_?gC§?± CÁ@*D6@w",
        ],
        xMin: 3,
        xMax: 515,
        yMin: -205,
        yMax: 707,
        wdth: 519
    },
    "z": {
        sC: [
            "F*G» A¹G» A¹IL H_IL H_H, C±Bw H}Bw H}AB AoAB AoBc F*G»",
        ],
        xMin: 22,
        xMax: 477,
        yMin: 0,
        yMax: 517,
        wdth: 500
    },
    "A": {
        sC: [
            "C6AB A4AB EXLV GcLV K«AB I}AB HwD< D<D< C6AB",
        ],
        hC: [
            ["F_Ja FXJa D£E{ H4E{ F_Ja"],
        ],
        xMin: -7,
        xMax: 675,
        yMin: 0,
        yMax: 714,
        wdth: 667
    },
    "\u00c1": {
        sC: [
            "",
            "C6AB A4AB EXLV GcLV K«AB I}AB HwD< D<D< C6AB",
        ],
        hC: [
            [],
            ["F_Ja FXJa D£E{ H4E{ F_Ja"],
        ],
        xMin: -7,
        xMax: 675,
        yMin: 0,
        yMax: 944,
        wdth: 667
    },
    "\u00c0": {
        sC: [
            "",
            "C6AB A4AB EXLV GcLV K«AB I}AB HwD< D<D< C6AB",
        ],
        hC: [
            [],
            ["F_Ja FXJa D£E{ H4E{ F_Ja"],
        ],
        xMin: -7,
        xMax: 675,
        yMin: 0,
        yMax: 944,
        wdth: 667
    },
    "\u00c3": {
        sC: [
            "",
            "C6AB A4AB EXLV GcLV K«AB I}AB HwD< D<D< C6AB",
        ],
        hC: [
            [],
            ["F_Ja FXJa D£E{ H4E{ F_Ja"],
        ],
        xMin: -7,
        xMax: 675,
        yMin: 0,
        yMax: 927,
        wdth: 667
    },
    "\u00c2": {
        sC: [
            "",
            "C6AB A4AB EXLV GcLV K«AB I}AB HwD< D<D< C6AB",
        ],
        hC: [
            [],
            ["F_Ja FXJa D£E{ H4E{ F_Ja"],
        ],
        xMin: -7,
        xMax: 675,
        yMin: 0,
        yMax: 944,
        wdth: 667
    },
    "\u00c4": {
        sC: [
            "",
            "",
            "C6AB A4AB EXLV GcLV K«AB I}AB HwD< D<D< C6AB",
        ],
        hC: [
            [],
            [],
            ["F_Ja FXJa D£E{ H4E{ F_Ja"],
        ],
        xMin: -7,
        xMax: 675,
        yMin: 0,
        yMax: 920,
        wdth: 667
    },
    "\u00c5": {
        sC: [
            "",
            "C6AB A4AB EXLV GcLV K«AB I}AB HwD< D<D< C6AB",
        ],
        hC: [
            [""],
            ["F_Ja FXJa D£E{ H4E{ F_Ja"],
        ],
        xMin: -7,
        xMax: 675,
        yMin: 0,
        yMax: 968,
        wdth: 667
    },
    "\u00c6": {
        sC: [
            "CJAB A4AB F{LV O{LV O{J¡ JBJ¡ JBG« ONG« ONF< JBF< JBB½ O©B½ O©AB HTAB HTD0 DwD0 CJAB",
        ],
        hC: [
            ["HTJ¡ G¯J¡ EREo HTEo HTJ¡"],
        ],
        xMin: -7,
        xMax: 930,
        yMin: 0,
        yMax: 714,
        wdth: 963
    },
    "B": {
        sC: [
            "GkAB BZAB BZLV G³LV IVLVJGK} K8K!K8Iu K8G¿ImGD ImG@ KyF©KyDP KyBÁJ}B6 IsABGkAB",
        ],
        hC: [
            ["G±FL DTFL DTB± G±B± I¡B±I¡Dq I¡FLG±FL","GmJ­ DTJ­ DTG£ GmG£ HHG£H¦H4 I>HiI>IF I>J­GmJ­"],
        ],
        xMin: 76,
        xMax: 667,
        yMin: 0,
        yMax: 714,
        wdth: 704
    },
    "C": {
        sC: [
            "K»H³ IÁH³ IVK,G:K, EeK,DoI¥ C«HoC«F¯ C«E*DoC¹ EeBmG:Bm HZBmI<CZ I¹D>J%Ec K½Ec K­CaJdB@ I<@ÃG:@Ã D¥@ÃCDB¡ A±DPA±F¯ A±IJCDJ¿ D¥LyG:Ly I0LyJVKy K¥JsK»H³",
        ],
        xMin: 38,
        xMax: 684,
        yMin: -17,
        yMax: 731,
        wdth: 722
    },
    "D": {
        sC: [
            "G*AB BZAB BZLV G*LV IeLVJ­J§ KÃIHKÃF¯ KÃDPJ­B· IeABG*AB",
        ],
        hC: [
            ["FJJ­ DTJ­ DTB± FJB± HZB±ILD! J%D½J%F¯ J%H¡ILIw HZJ­FJJ­"],
        ],
        xMin: 76,
        xMax: 687,
        yMin: 0,
        yMax: 714,
        wdth: 722
    },
    "E": {
        sC: [
            "JmAB BZAB BZLV J_LV J_J¡ DTJ¡ DTG« J#G« J#F< DTF< DTB½ JmB½ JmAB",
        ],
        xMin: 76,
        xMax: 597,
        yMin: 0,
        yMax: 714,
        wdth: 630
    },
    "\u00c9": {
        sC: [
            "",
            "JmAB BZAB BZLV J_LV J_J¡ DTJ¡ DTG« J#G« J#F< DTF< DTB½ JmB½ JmAB",
        ],
        xMin: 76,
        xMax: 597,
        yMin: 0,
        yMax: 928,
        wdth: 630
    },
    "\u00c8": {
        sC: [
            "",
            "JmAB BZAB BZLV J_LV J_J¡ DTJ¡ DTG« J#G« J#F< DTF< DTB½ JmB½ JmAB",
        ],
        xMin: 76,
        xMax: 597,
        yMin: 0,
        yMax: 928,
        wdth: 630
    },
    "\u00ca": {
        sC: [
            "",
            "JmAB BZAB BZLV J_LV J_J¡ DTJ¡ DTG« J#G« J#F< DTF< DTB½ JmB½ JmAB",
        ],
        xMin: 76,
        xMax: 597,
        yMin: 0,
        yMax: 928,
        wdth: 630
    },
    "\u00cb": {
        sC: [
            "",
            "",
            "JmAB BZAB BZLV J_LV J_J¡ DTJ¡ DTG« J#G« J#F< DTF< DTB½ JmB½ JmAB",
        ],
        xMin: 76,
        xMax: 597,
        yMin: 0,
        yMax: 904,
        wdth: 630
    },
    "F": {
        sC: [
            "DTAB BZAB BZLV J4LV J4J¡ DTJ¡ DTG« IZG« IZF< DTF< DTAB",
        ],
        xMin: 76,
        xMax: 569,
        yMin: 0,
        yMax: 714,
        wdth: 593
    },
    "G": {
        sC: [
            "GXG2 L8G2 L8AB J»AB JsBk I³A{I-AM HJ@ÃGD@Ã D¯@ÃCNB¡ A»DPA»F¯ A»IHCNJ¿ D¯LyGDLy I8LyJ]K} K¯J{L(H³ J4H³ J!I»I6Je HRK,GDK, EoK,DyI¥ CµHoCµF¯ CµE*DyC¹ EmBoGDBm H¥BkIjCS JPD<JTEu GXEu GXG2",
        ],
        xMin: 43,
        xMax: 699,
        yMin: -17,
        yMax: 731,
        wdth: 759
    },
    "H": {
        sC: [
            "DNAB BTAB BTLV DNLV DNGÁ IXGÁ IXLV KRLV KRAB IXAB IXFF DNFF DNAB",
        ],
        xMin: 73,
        xMax: 648,
        yMin: 0,
        yMax: 714,
        wdth: 722
    },
    "I": {
        sC: [
            "DTAB BZAB BZLV DTLV DTAB",
        ],
        xMin: 76,
        xMax: 201,
        yMin: 0,
        yMax: 714,
        wdth: 278
    },
    "J": {
        sC: [
            "FcLV H]LV H]D± H]C,G­B: F¿@ÃD©@Ã C.@ÃB@B# A]B½A]Dk A]E6 CVE6 CVDm CVCmC£C0 D.BmD½Bm E±BmF:C4 FcCqFcD£ FcLV",
        ],
        xMin: 13,
        xMax: 461,
        yMin: -17,
        yMax: 714,
        wdth: 537
    },
    "K": {
        sC: [
            "DTAB BZAB BZLV DTLV DTGL IPLV K§LV GJG¿ L,AB IuAB EÃFm DTE! DTAB",
        ],
        xMin: 76,
        xMax: 693,
        yMin: 0,
        yMax: 714,
        wdth: 685
    },
    "L": {
        sC: [
            "J*AB BZAB BZLV DTLV DTB½ J*B½ J*AB",
        ],
        xMin: 76,
        xMax: 564,
        yMin: 0,
        yMax: 714,
        wdth: 574
    },
    "M": {
        sC: [
            "DDAB BVAB BVLV E6LV H@Cy HDCy KDLV MÃLV MÃAB L2AB L2I³ L.I³ I!AB GTAB DHI³ DDI³ DDAB",
        ],
        xMin: 74,
        xMax: 815,
        yMin: 0,
        yMax: 714,
        wdth: 889
    },
    "N": {
        sC: [
            "D>AB BPAB BPLV DXLV IeD: IiD: IiLV KVLV KVAB INAB DDI] D>I] D>AB",
        ],
        xMin: 71,
        xMax: 650,
        yMin: 0,
        yMax: 714,
        wdth: 722
    },
    "\u00d1": {
        sC: [
            "",
            "D>AB BPAB BPLV DXLV IeD: IiD: IiLV KVLV KVAB INAB DDI] D>I] D>AB",
        ],
        xMin: 71,
        xMax: 650,
        yMin: 0,
        yMax: 955,
        wdth: 722
    },
    "O": {
        sC: [
            "G:Ly IsLyK0J¿ LgIHLgF¯ LgDPK0B¡ Is@ÃG:@Ã D¥@ÃCDB¡ A±DPA±F¯ A±IHCDJ¿ D¥LyG:Ly",
        ],
        hC: [
            ["G:K, EeK,DoI¥ C«HoC«F¯ C«E*DoC¹ EeBmG:Bm H³BmI©C¹ JmE*JmF¯ JmHoI©I¥ H³K,G:K,"],
        ],
        xMin: 38,
        xMax: 722,
        yMin: -17,
        yMax: 731,
        wdth: 760
    },
    "\u00d3": {
        sC: [
            "",
            "G:Ly IsLyK0J¿ LgIHLgF¯ LgDPK0B¡ Is@ÃG:@Ã D¥@ÃCDB¡ A±DPA±F¯ A±IHCDJ¿ D¥LyG:Ly",
        ],
        hC: [
            [],
            ["G:K, EeK,DoI¥ C«HoC«F¯ C«E*DoC¹ EeBmG:Bm H³BmI©C¹ JmE*JmF¯ JmHoI©I¥ H³K,G:K,"],
        ],
        xMin: 38,
        xMax: 722,
        yMin: -17,
        yMax: 928,
        wdth: 760
    },
    "\u00d2": {
        sC: [
            "",
            "G:Ly IsLyK0J¿ LgIHLgF¯ LgDPK0B¡ Is@ÃG:@Ã D¥@ÃCDB¡ A±DPA±F¯ A±IHCDJ¿ D¥LyG:Ly",
        ],
        hC: [
            [],
            ["G:K, EeK,DoI¥ C«HoC«F¯ C«E*DoC¹ EeBmG:Bm H³BmI©C¹ JmE*JmF¯ JmHoI©I¥ H³K,G:K,"],
        ],
        xMin: 38,
        xMax: 722,
        yMin: -17,
        yMax: 928,
        wdth: 760
    },
    "\u00d4": {
        sC: [
            "",
            "G:Ly IsLyK0J¿ LgIHLgF¯ LgDPK0B¡ Is@ÃG:@Ã D¥@ÃCDB¡ A±DPA±F¯ A±IHCDJ¿ D¥LyG:Ly",
        ],
        hC: [
            [],
            ["G:K, EeK,DoI¥ C«HoC«F¯ C«E*DoC¹ EeBmG:Bm H³BmI©C¹ JmE*JmF¯ JmHoI©I¥ H³K,G:K,"],
        ],
        xMin: 38,
        xMax: 722,
        yMin: -17,
        yMax: 928,
        wdth: 760
    },
    "\u00d6": {
        sC: [
            "",
            "",
            "G:Ly IsLyK0J¿ LgIHLgF¯ LgDPK0B¡ Is@ÃG:@Ã D¥@ÃCDB¡ A±DPA±F¯ A±IHCDJ¿ D¥LyG:Ly",
        ],
        hC: [
            [],
            [],
            ["G:K, EeK,DoI¥ C«HoC«F¯ C«E*DoC¹ EeBmG:Bm H³BmI©C¹ JmE*JmF¯ JmHoI©I¥ H³K,G:K,"],
        ],
        xMin: 38,
        xMax: 722,
        yMin: -17,
        yMax: 904,
        wdth: 760
    },
    "\u00d5": {
        sC: [
            "",
            "G:Ly IsLyK0J¿ LgIHLgF¯ LgDPK0B¡ Is@ÃG:@Ã D¥@ÃCDB¡ A±DPA±F¯ A±IHCDJ¿ D¥LyG:Ly",
        ],
        hC: [
            [],
            ["G:K, EeK,DoI¥ C«HoC«F¯ C«E*DoC¹ EeBmG:Bm H³BmI©C¹ JmE*JmF¯ JmHoI©I¥ H³K,G:K,"],
        ],
        xMin: 38,
        xMax: 722,
        yMin: -17,
        yMax: 911,
        wdth: 760
    },
    "P": {
        sC: [
            "DTAB BZAB BZLV GPLV IaLVJ]K< K6JLK6H¿ K6GoJ]F£ IaEgGPEg DTEg DTAB",
        ],
        hC: [
            ["GFJ­ DTJ­ DTG2 GBG2 H%G2HkGe I<H!I<HÁ I<J­GFJ­"],
        ],
        xMin: 76,
        xMax: 634,
        yMin: 0,
        yMax: 714,
        wdth: 667
    },
    "Q": {
        sC: [
            "J¿Bi LTAH KZ@@ I­Aw Hs@ÃG:@Ã D¥@ÃCDB¡ A±DPA±F¯ A±IHCDJ¿ D¥LyG:Ly IsLyK0J¿ LgIHLgF¯ LgD*J¿Bi",
        ],
        hC: [
            ["HZB± GJC¯ HBD¹ IqC¡ JmDµJmF¯ JmHoI©I¥ H³K,G:K, EeK,DoI¥ C«HoC«F¯ C«E*DoC¹ EeBmG:Bm G·BmHZB±"],
        ],
        xMin: 38,
        xMax: 722,
        yMin: -65,
        yMax: 731,
        wdth: 760
    },
    "R": {
        sC: [
            "DTAB BZAB BZLV G§LV ImLVJeKr K]J¯K]IT K]G>IqFm IqFi KDFJKDD: KDA¹KµAB I©AB IaA£IaB· IaDcI(E4 HkE±GDE± DTE± DTAB",
        ],
        hC: [
            ["GkJ­ DTJ­ DTGL GoGL IcGLIcI0 IcJ­GkJ­"],
        ],
        xMin: 76,
        xMax: 680,
        yMin: 0,
        yMax: 714,
        wdth: 704
    },
    "S": {
        sC: [
            "A§DÁ C¡DÁ C¡C¥DiC2 EFBmFiBm G¥BmHRC0 H¹CkH¹DD H¹EHGÃEu G³E{DwFk B:G@B:IT B:JÁC_Kµ DqLyFDLy H.LyIFK§ JiJ©JiI0 HoI0 H_K,F:K, ERK,D¯J© D4JTD4Is D4HiE_H; F«G±H{GL I£G#JLF8 J³EVJ³Da J³B£I_A« HD@ÃFX@Ã DT@ÃC6A½ A«BÃA§DÁ",
        ],
        xMin: 33,
        xMax: 615,
        yMin: -17,
        yMax: 731,
        wdth: 648
    },
    "T": {
        sC: [
            "D¹J¡ ARJ¡ ARLV JVLV JVJ¡ F³J¡ F³AB D¹AB D¹J¡",
        ],
        xMin: 8,
        xMax: 586,
        yMin: 0,
        yMax: 714,
        wdth: 593
    },
    "U": {
        sC: [
            "BJED BJLV DDLV DDE¹ DDDTDsC£ E<ByF·By HmByI6C£ IeDTIeE¹ IeLV K_LV K_ED K_C8J>B( I#@ÃF·@Ã D§@ÃCmB( BJC8BJED",
        ],
        xMin: 68,
        xMax: 654,
        yMin: -17,
        yMax: 714,
        wdth: 722
    },
    "\u00da": {
        sC: [
            "",
            "BJED BJLV DDLV DDE¹ DDDTDsC£ E<ByF·By HmByI6C£ IeDTIeE¹ IeLV K_LV K_ED K_C8J>B( I#@ÃF·@Ã D§@ÃCmB( BJC8BJED",
        ],
        xMin: 68,
        xMax: 654,
        yMin: -17,
        yMax: 928,
        wdth: 722
    },
    "\u00d9": {
        sC: [
            "",
            "BJED BJLV DDLV DDE¹ DDDTDsC£ E<ByF·By HmByI6C£ IeDTIeE¹ IeLV K_LV K_ED K_C8J>B( I#@ÃF·@Ã D§@ÃCmB( BJC8BJED",
        ],
        xMin: 68,
        xMax: 654,
        yMin: -17,
        yMax: 928,
        wdth: 722
    },
    "\u00db": {
        sC: [
            "",
            "BJED BJLV DDLV DDE¹ DDDTDsC£ E<ByF·By HmByI6C£ IeDTIeE¹ IeLV K_LV K_ED K_C8J>B( I#@ÃF·@Ã D§@ÃCmB( BJC8BJED",
        ],
        xMin: 68,
        xMax: 654,
        yMin: -17,
        yMax: 928,
        wdth: 722
    },
    "\u00dc": {
        sC: [
            "",
            "",
            "BJED BJLV DDLV DDE¹ DDDTDsC£ E<ByF·By HmByI6C£ IeDTIeE¹ IeLV K_LV K_ED K_C8J>B( I#@ÃF·@Ã D§@ÃCmB( BJC8BJED",
        ],
        xMin: 68,
        xMax: 654,
        yMin: -17,
        yMax: 904,
        wdth: 722
    },
    "V": {
        sC: [
            "G*AB D·AB A8LV C<LV F!Cm F%Cm H·LV JµLV G*AB",
        ],
        xMin: -5,
        xMax: 616,
        yMin: 0,
        yMax: 714,
        wdth: 611
    },
    "W": {
        sC: [
            "FHAB DFAB ANLV CLLV ENCµ ERCµ GsLV IsLV K­Cµ K±Cµ M»LV O¹LV L¯AB J±AB HqI© HmI© FHAB",
        ],
        xMin: 6,
        xMax: 938,
        yMin: 0,
        yMax: 714,
        wdth: 944
    },
    "X": {
        sC: [
            "A<AB E6G% A_LV C«LV FLH_ HÁLV K6LV G_G% KXAB I(AB FDEe CZAB A<AB",
        ],
        xMin: -3,
        xMax: 651,
        yMin: 0,
        yMax: 714,
        wdth: 648
    },
    "Y": {
        sC: [
            "GHAB ENAB ENEs A6LV CXLV FRGV IFLV K_LV GHEs GHAB",
        ],
        xMin: -6,
        xMax: 654,
        yMin: 0,
        yMax: 714,
        wdth: 648
    },
    "Z": {
        sC: [
            "H0J¡ B0J¡ B0LV JoLV JoJ» D.B½ J¥B½ J¥AB AqAB AqB± H0J¡",
        ],
        xMin: 23,
        xMax: 608,
        yMin: 0,
        yMax: 714,
        wdth: 630
    },
    "\u00a1": {
        sC: [
            "BRIi D_Ii D_Go BRGo BRIi",
            "C·FZ DVAm DV>T B]>T B]Am BÁFZ C·FZ",
        ],
        xMin: 72,
        xMax: 206,
        yMin: -183,
        yMax: 531,
        wdth: 278
    },
    "!": {
        sC: [
            "D_AB BRAB BRC< D_C< D_AB",
            "BÁDP B]I: B]LV DVLV DVI: C·DP BÁDP",
        ],
        xMin: 72,
        xMax: 206,
        yMin: 0,
        yMax: 714,
        wdth: 278
    },
    "|": {
        sC: [
            "C©@Ã B:@Ã B:Ly C©Ly C©@Ã",
        ],
        xMin: 60,
        xMax: 162,
        yMin: -17,
        yMax: 731,
        wdth: 222
    },
    '"': {
        sC: [
            "F·H! EHH! EHLV F·LV F·H!",
            "D4H! BiH! BiLV D4LV D4H!",
        ],
        xMin: 83,
        xMax: 361,
        yMin: 432,
        yMax: 714,
        wdth: 444
    },
    "'": {
        sC: [
            "D>H! BsH! BsLV D>LV D>H!",
        ],
        xMin: 88,
        xMax: 190,
        yMin: 432,
        yMax: 714,
        wdth: 278
    },
    "#": {
        sC: [
            "GwE} HÃE} HÃDg GcDg G%AB E©AB F@Dg DeDg D(AB B«AB CBDg A©Dg A©E} CXE} C}G£ B@G£ B@H¹ C³H¹ DJL: EmL: E0H¹ F±H¹ GHL: HkL: H.H¹ IZH¹ IZG£ G½G£ GwE}",
        ],
        hC: [
            ["FVE} F{G£ D¿G£ DyE} FVE}"],
        ],
        xMin: 34,
        xMax: 524,
        yMin: 0,
        yMax: 700,
        wdth: 556
    },
    "$": {
        sC: [
            "AeDu CHDu CDB]EHBT EHF8 CwFsB·G> A¥H,A¥Iq A¥K%B¯K· C¯LyEHLy EHM· EÁM· EÁLy G]LyHTK» ITK0ITIs GqIs GgKDEÁKD EÁGÁ G¡GcHgF· IyF%IyDc IyB¯HoA¹ GsA*EÁ@Ã EÁ?§ EH?§ EH@Ã CkA#BgAÂ AcB½AeDu",
        ],
        hC: [
            ["EÁF% EÁBT G·BgG·DB G·E(GHEa FµE«EÁF%","EHH4 EHKD CgKDCgI£ CgHmEHH4"],
        ],
        xMin: 17,
        xMax: 539,
        yMin: -95,
        yMax: 809,
        wdth: 556
    },
    "%": {
        sC: [
            "E4F: C«F:C2G0 BgG¹BgIH BgJwC6Ka C±LVE4LV FZLVG2Ka G¥JwG¥IH G¥G¹G6G0 FaF:E4F:",
            "LÃA% KuA%JÁA¿ JRB¥JRD4 JREcK!FL K{GBLÃGB NFGBNÁFL OoEcOoD4 OoB¥O!A¿ NLA%LÃA%",
            "Fg@µ EJ@µ KTLk LmLk Fg@µ",
        ],
        hC: [
            ["C½IH C½G<E2G< FNG<FNIH FNKTE2KT C½KTC½IH"],
            ["K©D4 K©B(LÁB( N:B(N:D4 N:F@LÁF@ K©F@K©D4"],
            [],
        ],
        xMin: 82,
        xMax: 918,
        yMin: -24,
        yMax: 724,
        wdth: 1000
    },
    "&": {
        sC: [
            "KoAB IVAB HTBc G:A%EDA% C}A%B¢Aº A¥B«A¥DN A¥FDDJGm C:I!C:J# C:K<CÂK½ D§LyE»Ly G,LyG³L! H}KDH}J! H}HBF{G8 HXE, HyE©H§Fm JLFm J4D»I]C± KoAB",
        ],
        hC: [
            ["GZC{ EBFV D<E§D4E} CgE8CgDJ CgCZD%B½ DgBZELBZ F8BZF£B· FÃC,GZC{","EÁKN E_KNE2K! D©JwD©J0 D©IuE4I0 E_H{E«HB FZH{F}I! G0I_G0J* G0JsF«JÃ FaKNEÁKN"],
        ],
        xMin: 32,
        xMax: 662,
        yMin: -14,
        yMax: 731,
        wdth: 648
    },
    "{": {
        sC: [
            "A:D§ A:F8 AyF8B.FV BwF¡BwGJ BwJg BwKeCVL6 D#LyDwLy F,Ly F,KD E>KD DNKDDNJ8 DNG2 DNFHC¡E³ CHEkB¡Ea B¡E] DNEHDNC¡ DN@§ DN?yE>?y F,?y F,>D Dw>D D#>DCV>© Bw?XBw@V BwCc BwD8B.De AyD§A:D§",
        ],
        xMin: -4,
        xMax: 309,
        yMin: -191,
        yMax: 731,
        wdth: 296
    },
    "}": {
        sC: [
            "E½F8 E½D§ E]D§E(Dg D_D>D_Cs D_@V D_?XC¡>© C0>DB_>D A(>D A(?y A¹?y B©?yB©@§ B©C­ B©DuCVE, C¯ERDVE] DVEa B©EuB©G> B©J8 B©KDA¹KD A(KD A(Ly B_Ly C0LyC¡L6 D_KeD_Jg D_GZ D_F§E(FX E]F8E½F8",
        ],
        xMin: -13,
        xMax: 300,
        yMin: -191,
        yMax: 731,
        wdth: 296
    },
    "(": {
        sC: [
            "E¡>D DD>D B#A±B#E_ B#I<DDLy E¡Ly C«I@C«E_ C«AeE¡>D",
        ],
        xMin: 49,
        xMax: 286,
        yMin: -191,
        yMax: 731,
        wdth: 278
    },
    ")": {
        sC: [
            "A2Ly BmLy D¯I,D¯E] D¯A}Bm>D A2>D C(AyC(E] C(IVA2Ly",
        ],
        xMin: -8,
        xMax: 229,
        yMin: -191,
        yMax: 731,
        wdth: 278
    },
    "*": {
        sC: [
            "B:H2 CFIo AiJ: A·K< CqJg CqLV DyLV DyJg FRK< F¥J: DÁIo F*H2 E@Ge D2I( C*Ge B:H2",
        ],
        xMin: 19,
        xMax: 352,
        yMin: 401,
        yMax: 714,
        wdth: 370
    },
    "+": {
        sC: [
            "B!F! E4F! E4I6 F£I6 F£F! IµF! IµDV F£DV F£AB E4AB E4DV B!DV B!F!",
        ],
        xMin: 48,
        xMax: 552,
        yMin: 0,
        yMax: 506,
        wdth: 600
    },
    ",": {
        sC: [
            "CVAB BLAB BLCP DcCP DcAB Dc@HCº?t CL>ÁBT>© BT?£ B·?³C6@G CX@¡CVAB",
        ],
        xMin: 69,
        xMax: 208,
        yMin: -158,
        yMax: 135,
        wdth: 278
    },
    "-": {
        sC: [
            "FkDw B#Dw B#FN FkFN FkDw",
        ],
        xMin: 49,
        xMax: 340,
        yMin: 218,
        yMax: 326,
        wdth: 389
    },
    ".": {
        sC: [
            "DcAB BLAB BLCP DcCP DcAB",
        ],
        xMin: 69,
        xMax: 208,
        yMin: 0,
        yMax: 135,
        wdth: 278
    },
    "/": {
        sC: [
            "Bq@Ã @¹@Ã ETLy G.Ly Bq@Ã",
        ],
        xMin: -22,
        xMax: 374,
        yMin: -17,
        yMax: 731,
        wdth: 352
    },
    ":": {
        sC: [
            "DcAB BLAB BLCP DcCP DcAB",
            "DcG( BLG( BLI6 DcI6 DcG(",
        ],
        xMin: 69,
        xMax: 208,
        yMin: 0,
        yMax: 506,
        wdth: 278
    },
    ";": {
        sC: [
            "DcG( BLG( BLI6 DcI6 DcG(",
            "CVAB BLAB BLCP DcCP DcAB Dc@HCº?t CL>ÁBT>© BT?£ B·?³C6@G CX@¡CVAB",
        ],
        xMin: 69,
        xMax: 208,
        yMin: -158,
        yMax: 506,
        wdth: 278
    },
    "<": {
        sC: [
            "D*E< I¹B¡ I¹A2 AÁDu AÁE§ I¹IF I¹G{ D*E<",
        ],
        xMin: 46,
        xMax: 554,
        yMin: -8,
        yMax: 514,
        wdth: 600
    },
    "=": {
        sC: [
            "B!DX IµDX IµB¯ B!B¯ B!DX",
            "B!Gm IµGm IµEÃ B!EÃ B!Gm",
        ],
        xMin: 48,
        xMax: 552,
        yMin: 101,
        yMax: 405,
        wdth: 600
    },
    ">": {
        sC: [
            "AÁA2 AÁB¡ G­E< AÁG{ AÁIF I¹E§ I¹Du AÁA2",
        ],
        xMin: 46,
        xMax: 554,
        yMin: -8,
        yMax: 514,
        wdth: 600
    },
    "\u00bf": {
        sC: [
            "DgGo DgIi FsIi FsGo DgGo",
            "GTA³ I8A³ I:@:H7?6 G4>2EX>2 C¿>2BÃ>¿ B#?©B#A< B#B8B]B¯ B{C<CWC­ D4DXDRD­ D§EXD§FZ F]FZ F]E4F6DZ E¹C±E@CD DcBsDNBZ CÁA¿CÁAD CÁ@_Dg?Ã DÁ?qEc?q FZ?qFº@> GT@¯GTA³",
        ],
        xMin: 49,
        xMax: 507,
        yMin: -200,
        yMax: 531,
        wdth: 556
    },
    "?": {
        sC: [
            "FoAB DcAB DcC< FoC< FoAB",
            "C«H³ B#H³ B!JoC$Kt D(LyE§Ly GBLyH=K¯ I8JÃI8Ie I8HiH£G· HcGeG«F» G(FHF­E¹ FXEHFXDF D£DF D£EmE%FF EFFµE¿G] F{H.F±HF G>H§G>I] G>JJFyJ« F>K:E{K: C«K:C«H³",
        ],
        xMin: 49,
        xMax: 507,
        yMin: 0,
        yMax: 731,
        wdth: 556
    },
    "@": {
        sC: [
            "I§I¡ J³I¡ I£Eq IqE2IqD¹ IqDgI·Dg JuDgKDEc K»FgK»G¹ K»IqJ{Jw IeKwG¥Kw E©KwDfJI CDH¿CDFÁ CDD¡DoCN EµB!G·B! J*B!KVCi LcCi K¥BNJdAx ID@ÃG¯@Ã ER@ÃC¡By B#DTB#G% B#IRC~K$ EVLyG¥Ly I·LyKVKT LÃJ*LÃH. LÃEÁKqDo J_CZIHCZ HXCZHRDN HNDN GiC]FoC] EsC]DÁD8 DJD·DJE¹ DJG_EBHy FDI¿G£I¿ H½I¿IaH¯ I§I¡",
        ],
        hC: [
            ["F·Ds G§DsHXEo I%F_I%GV I%G¿HxHQ HHH©G«H© F·H©F@G³ EuG#EuF( EuEXEÃE$ FLDsF·Ds"],
        ],
        xMin: 49,
        xMax: 751,
        yMin: -17,
        yMax: 731,
        wdth: 800
    },
    "[": {
        sC: [
            "E³>D BR>D BRLy E³Ly E³KD D*KD D*?y E³?y E³>D",
        ],
        xMin: 72,
        xMax: 295,
        yMin: -191,
        yMax: 731,
        wdth: 296
    },
    "]": {
        sC: [
            "ADLy D¥Ly D¥>D AD>D AD?y C*?y C*KD ADKD ADLy",
        ],
        xMin: 1,
        xMax: 224,
        yMin: -191,
        yMax: 731,
        wdth: 296
    },
    "^": {
        sC: [
            "E½JN D6Fa BkFa ERL: FcL: IJFa G¡Fa E½JN",
        ],
        xMin: 84,
        xMax: 516,
        yMin: 335,
        yMax: 700,
        wdth: 600
    },
    "_": {
        sC: [
            "I*@, I*?H AB?H AB@, I*@,",
        ],
        xMin: 0,
        xMax: 500,
        yMin: -125,
        yMax: -75,
        wdth: 500
    },
    "\u00a0": {
        sC: [],
        xMin: 0,
        xMax: 500,
        yMin: -125,
        yMax: -75,
        wdth: 278
    },
    " ": {
        sC: [],
        xMin: 0,
        xMax: 500,
        yMin: -125,
        yMax: -75,
        wdth: 278
    }
};
